import { ProductFormValues } from "../components";
import { ProductBothTogetherMethod, ProductVideoVariant } from "./enums";

export * from "./enums";

export const EMPTY_PRODUCT_FORM_VALUES: ProductFormValues = {
  description: "",
  googleDriveLink: "",
  isChapshopChoice: false,
  productVideoVariant: ProductVideoVariant.NO_VIDEO,
  productBothTogetherMethod: ProductBothTogetherMethod.NO_PRODUCTS,
  generalVideo: [],
  realVideo: [],
  sizes: [],
  additionalAttributesValuesIds: [],
  relatedAttributesValues: [],
  variants: [],
  colors: []
};

export const MIN_QTY_RANGE_VALUE = 2;
export const MAX_QTY_RANGE_VALUE = 999999;

export const STATUS_FILTER_SEARCH_PARAMETER = "status";
export const SIZES_FILTER_SEARCH_PARAMETER = "size";
export const COLORS_FILTER_SEARCH_PARAMETER = "colors";
export const MIN_PRICE_FILTER_SEARCH_PARAMETER = "minPrice";
export const MAX_PRICE_FILTER_SEARCH_PARAMETER = "maxPrice";

export const SHORT_PRODUCT_DETAILS_LIST_LENGHT = 4;
